import {Injectable} from "@angular/core";

@Injectable()
export class NativeWaiterAppService {

    chewzieNative: any;

    constructor() {
        console.log("--- NativeWaiterAppService");

        this.chewzieNative = window["chewzieNative"];
    }

    isAvailable(): boolean {
        return !!this.chewzieNative;
    }

    scanCreditCard(): string {
        return this.chewzieNative.scanCreditCard();
    }

    scanBarcode(): string {
        return this.chewzieNative.scanBarcode();
    }

    redirectToUrl(redirectUrl: string): void {
        this.chewzieNative.redirectToUrl(redirectUrl);
    }
}



// WEBPACK FOOTER //
// ./src/app/native-waiter-app.service.ts